/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDownloadUrlQueryVariables = Exact<{
  bucket: string;
  objectKey: string;
}>;


export type GetDownloadUrlQuery = { getDownloadUrl: { downloadUrl: string } | null };


export const GetDownloadUrlDocument = /*#__PURE__*/ gql`
    query GetDownloadUrl($bucket: String!, $objectKey: String!) {
  getDownloadUrl(bucket: $bucket, objectKey: $objectKey) {
    downloadUrl
  }
}
    `;

/**
 * __useGetDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadUrlQuery({
 *   variables: {
 *      bucket: // value for 'bucket'
 *      objectKey: // value for 'objectKey'
 *   },
 * });
 */
export function useGetDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadUrlQuery, GetDownloadUrlQueryVariables> & ({ variables: GetDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>(GetDownloadUrlDocument, options);
      }
export function useGetDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>(GetDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>;
export function useGetDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetDownloadUrlQuery | undefined, GetDownloadUrlQueryVariables>;
export function useGetDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>(GetDownloadUrlDocument, options);
        }
export type GetDownloadUrlQueryHookResult = ReturnType<typeof useGetDownloadUrlQuery>;
export type GetDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetDownloadUrlLazyQuery>;
export type GetDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetDownloadUrlSuspenseQuery>;
export type GetDownloadUrlQueryResult = Apollo.QueryResult<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>;